import { getCardData } from "@/lib/games/onePiece/getCardDataLocal";
import { getVersion } from "@/lib/version";
import { getLeaderSquare } from "@/lib/getLeaderImage";
import { CDN } from "@/lib/cdn";

// Re-export server-side functions for backwards compatibility
export {
  fetchLeadersServer as fetchLeaders,
  getLeaderDataServer as getLeaderData,
  getAllLeaderIdsServer as getAllLeaderIds,
  getLeaderDataAllServer as getLeaderDataAll,
} from "@/lib/api/leaders";

export function getLeaderId(leaderInfo: string | undefined) {
  if (!leaderInfo) {
    return "";
  }
  let match = leaderInfo.match(/\(([^)]+)\)/); // Regular expression to match content within parentheses
  if (match) {
    let contentWithinParentheses = match[1];
    return contentWithinParentheses;
  } else {
    return "";
  }
}

// Moved to interfaces/DeckIdentity so the shared handler contract does not
// depend on this One Piece module. Re-exported for existing importers.
import type { DeckIdentity } from "@/interfaces/DeckIdentity";
export type { DeckIdentity, LeaderData } from "@/interfaces/DeckIdentity";
type LeaderData = DeckIdentity;

export function getLeaderLife(leaderId: string) {
  const cardData = getCardData(leaderId);
  return cardData?.life;
}

export const getColorAbbreviation = (color: string): string => {
  // Defensive check for invalid color values
  if (!color || typeof color !== "string") {
    console.error("getColorAbbreviation called with invalid color:", color);
    return "";
  }

  // Handle single colors
  if (color === "Red") return "R";
  if (color === "Green") return "G";
  if (color === "Blue") return "U";
  if (color === "Purple") return "P";
  if (color === "Yellow") return "Y";
  if (color === "Black") return "B";

  // Handle color combinations
  const colors = color.split("/");
  if (colors.length === 2) {
    const [color1, color2] = colors;
    return `${getColorAbbreviation(color1)}${getColorAbbreviation(color2)}`;
  }

  return color; // Return original if no match
};

export function getLeaderAAImg(leaderId: string) {
  return `${CDN}/games/one-piece/images/leader-aa/${leaderId}.webp?v=${getVersion()}`;
}
